import { defineMessages } from 'react-intl';

const translations = {
  title: {
    id: 'pages.pick.pickAllDialog.title',
    defaultMessage: 'Pick all items',
    description: 'Title of the pick all dialog',
  },
  packTitle: {
    id: 'pages.pick.pickAllDialog.packTitle',
    defaultMessage: 'Pick and pack all items',
    description: 'Title of the pick all dialog when also packing',
  },
  message: {
    id: 'pages.pick.pickAllDialog.message',
    defaultMessage: 'Are you sure you would like to pick all items at once?',
    description: 'Message of the pick all dialog',
  },
  packMessage: {
    id: 'pages.pick.pickAllDialog.packMessage',
    defaultMessage:
      'Are you sure you would like to pick and pack all items at once? All items will be added to the current parcel.',
    description: 'Message of the pick all dialog when also packing',
  },
  actions: {
    cancel: {
      id: 'actions.cancel',
      defaultMessage: 'Cancel',
      description: 'Label of the cancel action of the pick all dialog',
    },
    pickAll: {
      id: 'actions.pickAll',
      defaultMessage: 'Pick all',
      description: 'Label of the pick all action of the pick all dialog',
    },
    pickAndPackAll: {
      id: 'actions.pickAndPackAll',
      defaultMessage: 'Pick and pack all',
      description: 'Label of the pick and pack all action of the pick all dialog',
    },
  },
  feedback: {
    pickAllFailed: {
      id: 'pages.pick.pickAllDialog.feedback.pickAllFailed',
      defaultMessage: 'Pick all items failed',
      description: 'Error message of the pick all action',
    },
    pickAndPackAllFailed: {
      id: 'pages.pick.pickAllDialog.feedback.pickAndPackAllFailed',
      defaultMessage: 'Pick and pack all items failed',
      description: 'Error message of the pick and pack all action',
    },
  },
};

export default defineMessages(translations);
